export default "__VITE_ASSET__u8v$ObuS__"